/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_No_Super_AdminsInputs */



/**
* | output |
* | --- |
* | "No administrators yet" |
*
* @param {Partner_Admin_No_Super_AdminsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_no_super_admins = /** @type {((inputs?: Partner_Admin_No_Super_AdminsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_No_Super_AdminsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Administratoren")
	return /** @type {LocalizedString} */ ("No administrators yet")
});